window.Admin.Offerings.Users = {}